'use client';

import { useMemo } from 'react';
import { haversineDistance } from '~/components/vm/MapSection/utils';
import { useGlobalContext } from '~/context/vm/GlobalContext';
import type { VendingMachineLocation } from '~/contracts/vm';
import useGetFetchGeocode from '~/hooks/vm/useGetGeocode';
import MapFinder from './MapFinder';

type OwnProps = {
  vendingMachineLocations: VendingMachineLocation[];
};

export default function MapSection({ vendingMachineLocations }: OwnProps) {
  const { currentZip, setCurrentZip, geoCoords, setGeoCoords, mapWrapperRef } =
    useGlobalContext();
  const fetchGeocode = useGetFetchGeocode();

  const sortedVendingMachines = useMemo(
    () =>
      geoCoords
        ? vendingMachineLocations
            .map(x => ({ ...x, distance: haversineDistance(x, geoCoords) }))
            .sort((a, b) => a.distance.mi - b.distance.mi)
        : vendingMachineLocations,
    [geoCoords, vendingMachineLocations]
  );

  return (
    <div ref={mapWrapperRef} className="mx-auto mb-[60px] mt-[2em] w-full">
      <MapFinder
        isNationwide
        vendingMachineLocations={sortedVendingMachines}
        currentZip={currentZip}
        onZipChange={setCurrentZip}
        onSubmit={fetchGeocode}
        setGeoCoords={setGeoCoords}
      />
    </div>
  );
}
